import PageLayout from '../components/PageLayout';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import useAuth from '../auth/useAuth';
import usePlugins from '../plugins/usePlugins';
import { pluginText } from '../plugins/pluginFrame';
import PageHeader from '../components/ui/PageHeader';
import PageBody from '../components/ui/PageBody';
import PageMain from '../components/ui/PageMain';

function CreateArticleChoice() {
  const { t, i18n } = useTranslation();
  const { user } = useAuth();
  const plugins = usePlugins();

  // An import (PDF, Rise course, interactive page) always starts an article, so news-only
  // authors don't see those.
  const canWriteArticles =
    user?.rightsAnywhere?.includes('articles.manage') ?? false;

  const choices = [
    {
      to: '/create-article/manual',
      icon: 'fa-solid fa-pen-to-square',
      title: 'createArticleChoice.manualButton',
      description: 'createArticleChoice.manualDescription',
    },
    {
      to: '/create-article/link',
      icon: 'fa-solid fa-link',
      title: 'createArticleChoice.linkButton',
      description: 'createArticleChoice.linkDescription',
    },
    ...(canWriteArticles
      ? [
        {
          to: '/create-article/upload',
          icon: 'fa-solid fa-file-pdf',
          title: 'createArticleChoice.pdfButton',
          description: 'createArticleChoice.pdfDescription',
        },
        {
          to: '/create-article/rise',
          icon: 'fa-solid fa-graduation-cap',
          title: 'createArticleChoice.riseButton',
          description: 'createArticleChoice.riseDescription',
        },
        {
          to: '/create-article/interactive',
          icon: 'fa-solid fa-diagram-project',
          title: 'createArticleChoice.interactiveButton',
          description: 'createArticleChoice.interactiveDescription',
        },
      ]
      : []),
    // Plugins offering a card, where the author holds the card's right; the
    // server asks again for the department the article ends up in.
    ...(plugins ?? [])
      .filter((plugin) => plugin.ui?.createArticle && plugin.block?.editor
        && user?.rightsAnywhere?.includes(plugin.ui.createArticle.right))
      .map((plugin) => ({
        to: `/create-article/plugin/${plugin.id}`,
        icon: plugin.ui.createArticle.icon,
        label: pluginText(plugin.ui.createArticle.title, i18n.language),
        text: pluginText(plugin.ui.createArticle.description, i18n.language),
      })),
  ];

  return (
    <PageLayout
      showSearch
      showAiSearch
    >
      <PageMain className="article-page">

        <PageHeader title={t('createArticleChoice.title')} condensed />


        <PageBody className="page-body--split">
          <div className="maincol">
            <div className="create-choice-grid">
              {choices.map((choice) => (
                <Link key={choice.to} to={choice.to} className="create-choice-card">
                  <span className="create-choice-card__icon" aria-hidden="true">
                    <i className={choice.icon} />
                  </span>

                  <span className="create-choice-card__text">
                    <span className="create-choice-card__title">{choice.label ?? t(choice.title)}</span>
                    <span className="create-choice-card__description">{choice.text ?? t(choice.description)}</span>
                  </span>

                  <i className="fa-solid fa-arrow-right create-choice-card__arrow" aria-hidden="true" />
                </Link>
              ))}
            </div>
          </div>
        </PageBody>

      </PageMain>
    </PageLayout>
  );
}

export default CreateArticleChoice;
